import React, { useState } from "react";
import "./Header.css";
import { NavLink, Link } from "react-router-dom";
import { settings } from "../../portfolio.js";
import SeoHeader from "../seoHeader/SeoHeader";

function Header({ theme, onToggle, isDark }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const link = settings.isSplash ? "/splash" : "/home";
  const nightMode = isDark !== false;
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <>
      <SeoHeader />
      <header
        className={`route-header${isMenuOpen ? " is-menu-open" : ""}`}
        style={{
          "--route-text": theme.text,
          "--route-muted": theme.secondaryText,
          "--route-accent": theme.imageHighlight,
          "--route-panel": theme.body,
        }}
      >
        <div className="route-header-inner">
          <NavLink
            to={link}
            tag={Link}
            className="route-brand"
            aria-label="Go to home"
            onClick={closeMenu}
          >
            <span className="route-brand-mark">SG</span>
            <span className="route-brand-copy">
              PRIVATE INTELLIGENCE
              <br />
              OBSERVATORY
            </span>
          </NavLink>
          <button
            type="button"
            className="route-menu-icon"
            onClick={() => setIsMenuOpen((open) => !open)}
            aria-label="Toggle navigation"
            aria-expanded={isMenuOpen}
            aria-controls="portfolio-navigation"
          >
            <span></span>
            <span></span>
          </button>
          <nav
            id="portfolio-navigation"
            className="route-nav"
            aria-label="Portfolio sections"
          >
            <NavLink
              exact
              to="/home"
              tag={Link}
              activeClassName="is-active"
              onClick={closeMenu}
            >
              Overview
            </NavLink>
            <NavLink
              to="/experience"
              tag={Link}
              activeClassName="is-active"
              onClick={closeMenu}
            >
              Experience
            </NavLink>
            <NavLink
              to="/projects"
              tag={Link}
              activeClassName="is-active"
              onClick={closeMenu}
            >
              Projects
            </NavLink>
            <NavLink
              to="/opensource"
              tag={Link}
              activeClassName="is-active"
              onClick={closeMenu}
            >
              GitHub
            </NavLink>
            <NavLink
              to="/education"
              tag={Link}
              activeClassName="is-active"
              onClick={closeMenu}
            >
              Education
            </NavLink>
            <NavLink
              to="/contact"
              tag={Link}
              className="route-nav-cta"
              activeClassName="is-active"
              onClick={closeMenu}
            >
              Contact
            </NavLink>
            <button
              type="button"
              className="route-theme-toggle"
              onClick={() => {
                closeMenu();
                onToggle();
              }}
              title={
                nightMode ? "Switch to paper mode" : "Switch to night mode"
              }
              aria-label={
                nightMode ? "Switch to paper mode" : "Switch to night mode"
              }
            >
              {nightMode ? "☼" : "◐"}
            </button>
          </nav>
        </div>
        <span className="route-header-scan" aria-hidden="true"></span>
      </header>
    </>
  );
}

export default Header;
